<div class="dialog-footer-container">
    <button>next</button>
    <button>close</button>
</div>